// Angular
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
// Partials for CRUD
import {
    ActionNotificationComponent,
    DeleteEntityDialogComponent,
    FetchEntityDialogComponent,
    UpdateStatusDialogComponent,
    ModalAlertComponent,
    PdfViewerDialogComponent,
    PdfViewerDialogRevisedComponent
} from '../../../../views/partials/content/crud';
import { CompareViewComponent } from 'app/views/partials/content/general/compare-view/compare-view.component';
import { RevisedInvoiceOptionsComponent } from 'app/views/partials/content/general/revised-invoice-options/revised-invoice-options.component';
import { EditMastersComponent } from 'app/views/partials/content/general/edit-masters/edit-masters.component';
import { InvoicePODialogComponent } from 'app/views/partials/content/general/invoice-po-comparinson-dialog/invoice-po-comparinson-dialog.component';
import { WaitingDialogComponent } from 'app/views/partials/content/crud/waiting-dialog/waiting-dialog.component';


export enum MessageType {
    Create,
    Read,
    Update,
    Delete
}

@Injectable()
export class LayoutUtilsService {
	isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    /**
     * Service constructor
     *
     * @param snackBar: MatSnackBar
     * @param dialog: MatDialog
     */
    constructor(
        private snackBar: MatSnackBar,
        private dialog: MatDialog
    ) { }

    /**
     * Showing (Mat-Snackbar) Notification
     *
     * @param message: string
     * @param type: MessageType
     * @param duration: number
     * @param showCloseButton: boolean
     * @param showUndoButton: boolean
     * @param undoButtonDuration: number
     * @param verticalPosition: 'top' | 'bottom' = 'top'
     */
    showActionNotification(
        _message: string,
        _type: MessageType = MessageType.Create,
        _duration: number = 10000,
        _showCloseButton: boolean = true,
        _showUndoButton: boolean = true,
        _undoButtonDuration: number = 3000,
        _verticalPosition: 'top' | 'bottom' = 'bottom'
    ) {
        const _data = {
            message: _message,
            snackBar: this.snackBar,
            showCloseButton: _showCloseButton,
            showUndoButton: _showUndoButton,
            undoButtonDuration: _undoButtonDuration,
            verticalPosition: _verticalPosition,
            type: _type,
            action: 'Undo'
        };
        return this.snackBar.openFromComponent(ActionNotificationComponent, {
            duration: _duration,
            data: _data,
            verticalPosition: _verticalPosition
        });
    }

    /**
     * Showing Confirmation (Mat-Dialog) before Entity Removing
     *
     * @param title: stirng
     * @param description: stirng
     * @param waitDesciption: string
     */
    deleteElement(title: string = '', description: string = '', waitDesciption: string = '') {
        return this.dialog.open(DeleteEntityDialogComponent, {
            data: { title, description, waitDesciption },
            width: '440px'
        });
    }

    /**
     * Showing Fetching Window(Mat-Dialog)
     *
     * @param _data: any
     */
    fetchElements(_data) {
        return this.dialog.open(FetchEntityDialogComponent, {
            data: _data,
            width: '400px'
        });
    }

    /**
     * Showing Update Status for Entites Window
     *
     * @param title: string
     * @param statuses: string[]
     * @param messages: string[]
     */
    updateStatusForEntities(title, statuses, messages) {
        return this.dialog.open(UpdateStatusDialogComponent, {
            data: { title, statuses, messages },
            width: '480px'
        });
    }

    /**
     * Showing general message in alert/dialog window
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2019-12-2
     */
    public generalAlert() {
		if (this.isMobile) {
			return this.dialog.open(ModalAlertComponent, {
				panelClass: 'kt-modal-alert-dialog',
			});
		}
		return this.dialog.open(ModalAlertComponent, {
			width: '500px',
			maxWidth: '95vw',
			panelClass: 'kt-modal-alert-dialog',
		});
	}

	public generalAlertSize(size: string) {
		return this.dialog.open(ModalAlertComponent, {
			width: size,
			maxWidth: '95vw',
			panelClass: 'kt-modal-alert-dialog',
		});
	}

    /**
     * Showing general message in alert/dialog window
     * @param widthCustom width of the dialog
     * @param heightCustom height of the dialog
     *
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2019-12-4
     */
    public pdfViewer(widthCustom: string, heightCustom: string, disableCloseFlag: boolean = false) {
        return this.dialog.open(PdfViewerDialogComponent, {
            width: widthCustom,
            height: heightCustom,
            disableClose: disableCloseFlag
        });
    }
    public pdfRevisedViewer(widthCustom: string, heightCustom: string) {
        return this.dialog.open(PdfViewerDialogRevisedComponent, {
            width: widthCustom,
            height: heightCustom
        });
    }

    public showWaitingPopup(message: string): MatDialogRef<WaitingDialogComponent> {
        const dialogRef = this.dialog.open(WaitingDialogComponent, {
          data: { message: message },
          disableClose: true // Para que el usuario no lo cierre accidentalmente
        });
        return dialogRef;
    }

    /**
     * Showing general message in alert/dialog window
     * @param widthCustom width of the dialog
     * @param heightCustom height of the dialog
     *
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-9
     */
    public pdfComparison(widthCustom: string, heightCustom: string) {
        return this.dialog.open(CompareViewComponent, {
            width: widthCustom,
            height: heightCustom
        });
    }

	 /**
     * Showing general message in alert/dialog window
     * @param widthCustom width of the dialog
     * @param heightCustom height of the dialog
     *
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-07-9
     */
	  public pdfInvoicePOComparison(widthCustom: string, heightCustom: string, showLoading?: boolean, showButtons?: boolean) {
        const modalRefer = this.dialog.open(InvoicePODialogComponent, {
            width: widthCustom,
            height: heightCustom
        });
        modalRefer.componentInstance.showLoading = (showLoading !== undefined && showLoading) ? true : false;
        // modalRefer.componentInstance.showButtons = (showButtons !== undefined && showButtons) ? true : false;
        return modalRefer;
    }
    /**
     * Showing general message in alert/dialog window
     * @param widthCustom width of the dialog
     * @param heightCustom height of the dialog
     *
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-10-02
     */
    revisedInvoiceOptions(widthCustom: string, heightCustom: string) {
        return this.dialog.open(RevisedInvoiceOptionsComponent, {
            width: widthCustom,
            height: heightCustom
        });
    }

    /**
     * Show a edit form for any master edit
     * @param widthCustom width of the dialog
     * @param heightCustom height of the dialog
     *
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-11-25
     */
    editMasters(widthCustom: string, heightCustom: string) {
        return this.dialog.open(EditMastersComponent, {
            width: widthCustom,
            height: heightCustom
        });
    }
}
